module.exports = __webpack_public_path__ + "logowhite.ee7c4679.png";